import { useCallback, useEffect, useState } from "react";
import type { RoasterColor } from "../types";
import { api } from "../lib/api";

export function useRoasterColors() {
  const [data, setData] = useState<RoasterColor[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    setError(null);
    api.listRoasterColors().then(setData).catch((e: Error) => setError(e.message));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh };
}

export interface RoasterStyle {
  bg: string;
  text: string;
  bold: boolean;
  italic: boolean;
}

// Convenient lookup map: roaster name → style spec.
export function indexByRoaster(list: RoasterColor[] | null): Map<string, RoasterStyle> {
  const m = new Map<string, RoasterStyle>();
  for (const c of list || []) m.set(c.roaster, { bg: c.bg_color, text: c.text_color, bold: !!c.bold, italic: !!c.italic });
  return m;
}
